__turbopack_context__.v({
  "product-card": "G3pxWq_product-card",
  "product-card--dark": "G3pxWq_product-card--dark",
  "product-card--faint": "G3pxWq_product-card--faint",
  "product-card--image": "G3pxWq_product-card--image",
  "product-card--stacked": "G3pxWq_product-card--stacked",
  "product-card--video": "G3pxWq_product-card--video",
  "product-card__bg": "G3pxWq_product-card__bg",
  "product-card__bg--desktop": "G3pxWq_product-card__bg--desktop",
  "product-card__bg--mobile": "G3pxWq_product-card__bg--mobile",
  "product-card__bg--stacked": "G3pxWq_product-card__bg--stacked",
  "product-card__content": "G3pxWq_product-card__content",
  "product-card__content--stacked": "G3pxWq_product-card__content--stacked",
  "product-card__description": "G3pxWq_product-card__description",
  "product-card__icon": "G3pxWq_product-card__icon",
  "product-card__media-button": "G3pxWq_product-card__media-button",
  "product-card__tertiary-cta": "G3pxWq_product-card__tertiary-cta",
  "product-card__title": "G3pxWq_product-card__title",
});
